module.exports = __webpack_public_path__ + "static/img/shop.5623ec6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/shop.png
// module id = gDzo
// module chunks = 1